/**
 * @packageDocumentation
 * @module f1/boolean
 */

export interface ToTrue {
  /**
   * Same as `true`
   *
   * @public
   * @function f1.to.true
   * @example
   *
   * ```ts
   * f1.to.true() === true
   * f1.to.true(120) === true
   * ```
   */
  (v: unknown): true;
}

/**
 * @see ToTrue
 */
export default (): true => true;
